import sharedModule from '../../shared.module';

class asLoadingMask {
    constructor() {
        this.counter = 0;
        this.showMask = false;
    }

    show() {
        this.counter++;
        this.setShowMaskBasedOnCounter();

        return this;
    }

    hide() {
        this.counter--;
        this.setShowMaskBasedOnCounter();

        return this;
    }

    setShowMaskBasedOnCounter() {
        this.showMask = this.counter > 0 ? true : false;
    }
}

export default sharedModule.service('asLoadingMask', asLoadingMask);



// WEBPACK FOOTER //
// ./modules/shared/services/asLoadingMask/asLoadingMask.service.js